import React from 'react';
import { connect } from 'react-redux';
import '../../styles/play_styles.scss';
import config from '../../configuration.json';
import Navbar from './play_Navbar';
import Footer from './play_Footer';
import MyModal from '../../modal/newModal';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { setDocusig } from '../../actions';
import { Navigate } from 'react-router-dom';

class Form extends React.Component {

    state = {
        scale: false,
        name: '', lastName: '', email: '', phone: '', useNavigation: null
    };

    componentDidMount() {

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        if (window.innerWidth <= 760) {
            this.setState({ scale: true });
        }
        else {
            this.setState({ scale: false });
        }
    }


    nextStep(registerResult) {
        setTimeout(() => {
            this.setState({ useNavigation: <Navigate to={`/${process.env.REACT_APP_HOME}/recibido`} replace={true} /> });
        }, 100);
    }

    handlerError() {
        this.setState({ renderModal: <MyModal title="Error" content="Ha ocurrido algún error inesperado. Vuelve a intentarlo más tarde" /> });
    }
    onClose() {
        document.location.href = this.props.docusign;
    }
    render() {
           return (
            <div>
                {this.state.useNavigation}
                <Navbar image={config.PlayAndPizza.HeaderIconlUrl} />

                <div className="sm-card">
                    <h1 className="sm-title">OK, genial</h1>

                    <p className="sm-text">
                       Ya tenemos tus datos, ahora solo falta completar la carta de aceptación. Sólo tienes 24horas desde ahora para hacerlo.
                    </p>

                    <button className="sm-btn" onClick={() => this.onClose()}>
                        IR A FIRMAR
                    </button>
                </div>

                {this.state.renderModal}
                <Footer footerName="thank-you-footer" />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        docusign: state.pageReducer.docusign,
    };
};

export default connect(mapStateToProps, { setDocusig })(Form);


